module.exports = fox._r("images/preloader.png", __webpack_public_path__ + "images/preloader.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/preloader.png
// module id = 1094
// module chunks = 4